import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, FormControlLabel, Grid, Box } from '@mui/material';
import { defaultRHFSetValueOptions } from '@efacity/react-hook-form-mui';
import cloneDeep from 'lodash/cloneDeep';
import { racesOptions } from '@efacity/common';

export const Race: React.FC<{ pathToFormObject?: string; disabled?: boolean }> = ({
  pathToFormObject = '',
  disabled = false
}) => {
  const { watch, setValue } = useFormContext();
  const race: string[] = cloneDeep(watch(`${pathToFormObject}.race`) || []);

  const onRaceChanged = (raceItem: string) => {
    if (race.includes(raceItem)) {
      setValue(
        `${pathToFormObject}.race`,
        cloneDeep(race.filter((item) => item !== raceItem)),
        defaultRHFSetValueOptions
      );
    } else {
      setValue(`${pathToFormObject}.race`, [...race, raceItem], defaultRHFSetValueOptions);
    }
  };

  return (
    <Box style={{ borderStyle: 'groove', borderWidth: '1px', padding: '10px' }}>
      <>
        Race / Ethnicity *
        {racesOptions.map((raceItem, index) => {
          return (
            <Grid size={{ xs: 12 }} key={`raceKey${index}`}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={race.includes(raceItem)}
                    onChange={() => onRaceChanged(raceItem)}
                    style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}
                    disabled={disabled}
                  />
                }
                label={raceItem}
                disabled={disabled}
              />
            </Grid>
          );
        })}
      </>
    </Box>
  );
};
